<template>
    <div class="scorll" style="width: 100%;">

        <!-- <div class="parking-text">苏州园区停车场</div> -->
        <div class="fex">
            <!-- <el-button type="primary" class="loginOut" @click="rememberMeValue">退出登录</el-button> -->
        <div class="tips">


            <!-- <div class="status">车位状态</div> -->
            <div class="color">
                <div style="background-color: #EEEEEE; width: 20px; height: 20px;"></div><span>空闲</span>
            </div>
            <div class="color">
                <div style="background-color: #FFFF01; width: 20px; height: 20px;"></div><span>待确认</span>
            </div>
            <div class="color">
                <div style="background-color: rgb(255 154 0 / 65%); width: 20px; height: 20px;"></div><span>异常</span>
            </div>
            <div class="color">
                <div style="background-color: red; width: 20px; height: 20px;"></div><span>已确认</span>
            </div>




        </div>
        </div>
      
        <cube-scroll :options="scrollOptions" ref="scroll" class="cube-scroll">


            <ul v-for="(item, index) in parkingInfoList">
                <div>{{ item.areaName }}</div>
                <li v-for="(itemlist, i) in item.parkingInfoList" :class="{
                        'greyText': itemlist.status == 0, 'orangeText': itemlist.status == 1 || itemlist.status == 4,
                        'redText': itemlist.status == 2, 'yellowText': itemlist.status == 3
                    }" class="spanvi" @click="dialogVisibles(itemlist)">
                    {{ itemlist.parkingName }}
                </li>
            </ul>

         
        </cube-scroll>


        <el-dialog title="车牌号" :visible.sync="dialogVisible" width="30%">
            <el-input style="margin: 10px 0;" v-model="input" placeholder="请输入车牌号"></el-input>
            <el-button type="primary">进场</el-button>
            <el-button type="success">出场</el-button>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
            </span>
        </el-dialog>




    </div>
</template>

<script>

import { getRsParkList } from "@/api/coupon/admin";
import Cookies from "js-cookie";

export default {
    name: "index",
    data() {
        return {
            rememberMe: "",
            parkingInfoList: [],
            dialogVisible: false,
            isReceipt: true,
            isBusinessManager: 0,
            Token: "",
            scrollOptions: {
                click: true,
                bounce: false
            },
        }
    },

    created() {




        
        // this.Token = Cookies.get('Token')
        // console.log(this.Token,'this.Token');
        // if (this.Token!=undefined) {
        //     this.Token = Cookies.get('Token')
           
            this.ParkList()
        // } else {
        //     Cookies.remove('rememberMe');
        //     this.$weui.alert('登录过期，请重新登录')
        //     this.$router.push({ name: 'Login', })
        // }

        // this.isReceipt = this.$route.query.isReceipt;
        // if (this.userOpenid || localStorage.getItem('userOpenId')) this.getUserInfo()
    },
    methods: {
        rememberMeValue() {

            Cookies.remove('rememberMe')
            this.$router.push({ name: 'Login', })
        },
        orderScroll(e) {
            console.log(e, '滑动');
        },
        dialogVisibles(val) {
            console.log(val, '123456879');
            val.lotId = val.lotId - 10000
            // this.dialogVisible = true
            // console.log(val,"val");

            this.$router.push({ name: 'ParkingSpace', query: { parkingName: val.parkingName, parkId: val.id, lotId: val.lotId } })
        },



        /*获取用户信息**/
        // getUserInfo() {
        //     getWxUserInfo(this.userOpenid || localStorage.getItem('userOpenId')).then(res => {
        //         this.setBusinessIds(res.data.businessIds);
        //         this.isBusinessManager = res.data.isBusinessManager
        //     })
        // },
        ParkList() {
            getRsParkList(this.token).then(res => {
                console.log(res, '12345678');
                this.parkingInfoList = res.data
                this.$nextTick(() => {
                    this.$refs.scroll.refresh()
                })
            })
        }

    }
}
</script>
<style>
body {
    -webkit-overflow-scrolling: touch;
    -ms-scroll-chaining: touch;
}

.tips {
    align-items: center;
    height: 50px;
    margin: 10px 10px;
    display: flex;

}

.scorll {
    height: 100%;
    position: static;
    left: 0;
    right: 0;
    top: 0
}

.status {
    font-size: 18px;
}

.color {
    font-size: 18px;
    display: flex;
    margin: 10px 10px;
    align-items: center;
}

.loginOut {
    float: right;
   margin-top: 20px !important;
}

.ovw {
    height: 500px;
    overflow-y: scroll;
    overflow: auto;
    width: 390px;
    margin: auto;


}
.fex{
    display: flex;
    flex-direction: column;
}

.cube-scroll {
    position: relative;
    text-align: left;
    white-space: normal;
    max-height: 80%;
    overflow: hidden;
    /*background: #ffffff;*/
    margin-bottom: 50px;
}



.ovw>ul {
    height: 100vh;
    overflow: auto;
    margin: 20px 0;



}

.redText {

    background-color: red;
}

.yellowText {
    background-color: rgb(255 154 0 / 65%);
}

.orangeText {
    /* background-color: rgb(243 111 66); */
    background-color: #FFFF01;
}

.greyText {

    background-color: #EEEEEE;
}

.spanvi {
    margin: 10px 6px auto;
    text-align: center;
    line-height: 80px;
    display: inline-block;
    /* border: 1px solid black;*/
    border-radius: 4px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);
    /* border-radius: 10px; */
    /* background-color: red; */
    width: 80px;
    height: 80px;
    text-align: center;

}

.parking-text {
    text-align: center;
    font-size: 26px;
    /* line-height: 50px; */
    height: 50px;
    /* width: 200px; */
    margin: 10px 0 auto;
}
</style>

<style scoped lang="stylus">
    >>>.el-button--primary{
        padding-top: 20px;
    }
</style>
